import classNames from 'classnames'
import { selectProgramType } from 'legacy/lut/features/partner360/configuration'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'
import { SupportButton } from 'partner360/components/supportButton'

import { getStrSeparatedByUpperCase } from '../helpers/getStrSeparatedByUpperCase'

import { HelpSection } from './enums/HelpSection'
import { getAlignMods } from './helpers/getAlignMods'
import { getLinkBySectionAndProgramType } from './helpers/getLinkBySectionAndProgramType'
import { TAlign } from './models'

import styles from './HelpButton.module.scss'

interface IProps {
  section: HelpSection
  className?: string
  align?: TAlign
}

export const HelpButton = ({ section, align, className }: IProps) => {
  const programType = useSelector(selectProgramType)

  const link = useMemo(() => {
    if (programType && section) {
      return getLinkBySectionAndProgramType({ section, programType })
    }
    return null
  }, [section, programType])

  const alignMods = useMemo(() => getAlignMods(styles, align), [align])

  if (!link) {
    return null
  }

  return (
    <div className={classNames(styles.wrap, alignMods, className)}>
      <Tooltip
        tipContent={() => (
          <Translation text={getStrSeparatedByUpperCase(`jbp-help-btn-for-section${section}`)} />
        )}
      >
        <SupportButton
          variant={'text'}
          className={styles.icon}
          href={link}
          target={'_blank'}
          rel="noreferrer"
          iconButton="kbase kbase-question"
        />
      </Tooltip>
    </div>
  )
}
